export default __webpack_public_path__ + "static/media/ScrollMagenta.dea838c6.svg";